import { useMemo } from 'react';
import question from '~/assets/icons/question_2.svg';
import {
	Button,
	ButtonBorderRadius,
	ButtonColors,
	ButtonHeight,
} from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { CharacterSkill } from '~/shared';
import {
	setActiveModalSkill,
	setModalSkillsVisible,
	useLayoutDispatch,
} from '../../redux';
import {
	StyledBottomContainer,
	StyledContainer,
	StyledLevel,
	StyledProgress,
	StyledProgressWrapper,
	StyledTitleContainer,
	StyledTopContainer,
} from './StatsSkillItem.styled';

interface IStatsSkillItemProps {
	name: string;
	skill: CharacterSkill;
	level: number;
	current: number;
	target: number;
	isMaxLevel?: boolean;
}

const StatsSkillItem = ({
	name,
	skill,
	level,
	current,
	target,
	isMaxLevel,
}: IStatsSkillItemProps) => {
	const dispatch = useLayoutDispatch();

	const isInactive = useMemo(() => {
		return level <= 1;
	}, [level]);

	return (
		<StyledContainer>
			<StyledTopContainer>
				<StyledTitleContainer>
					<Text>Навык</Text>
					<Text>{name}</Text>
				</StyledTitleContainer>
				<StyledLevel $isMaxLevel={isMaxLevel} $isInactive={isInactive}>
					<Text>{level}</Text>
				</StyledLevel>
			</StyledTopContainer>
			<StyledBottomContainer>
				<StyledProgressWrapper>
					<StyledProgress style={{ width: `${(current / target) * 100}%` }} />
				</StyledProgressWrapper>
				<Button
					color={ButtonColors.Default}
					height={ButtonHeight.Height20}
					borderRadius={ButtonBorderRadius.Radius5}
					onClick={() => {
						dispatch(setActiveModalSkill(skill));
						dispatch(setModalSkillsVisible(true));
					}}
				>
					<img src={question} />
				</Button>
			</StyledBottomContainer>
		</StyledContainer>
	);
};

export { StatsSkillItem };
